import { client, deserializeJSONString } from '@trello/graphql';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from '@trello/redux';

// eslint-disable-next-line no-restricted-imports
import { CardResponse } from 'app/gamma/src/types/responses';
import { StandardThunkAction } from '../../types';
import {
  LoadCanonicalCardDocument,
  LoadCanonicalCardQuery,
  LoadCanonicalCardQueryVariables,
} from './LoadCanonicalCardQuery.generated';

// eslint-disable-next-line no-restricted-imports
import { Dispatch } from 'app/gamma/src/types';

// Action types
export const LOAD_CARD_REQUEST = Symbol('loaders/LOAD_CARD_REQUEST');
export const LOAD_CARD_SUCCESS = Symbol('loaders/LOAD_CARD_SUCCESS');

export type LoadCardRequestAction = Action<typeof LOAD_CARD_REQUEST, string>;
export type LoadCardSuccessAction = Action<
  typeof LOAD_CARD_SUCCESS,
  CardResponse
>;

// Action creators
const loadCardRequest = actionCreator<LoadCardRequestAction>(LOAD_CARD_REQUEST);
const loadCardSuccess = actionCreator<LoadCardSuccessAction>(LOAD_CARD_SUCCESS);

export const loadCanonicalCard = (idCard: string): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    dispatch(loadCardRequest(idCard));
    const { data, error } = await client.query<
      LoadCanonicalCardQuery,
      LoadCanonicalCardQueryVariables
    >({
      query: LoadCanonicalCardDocument,
      variables: {
        id: idCard,
      },
      context: {
        operationName: 'LoadCanonicalCard',
        document: LoadCanonicalCardDocument,
      },
    });
    const card = data.card;
    if (error || !card) {
      return;
    }
    const dataToDispatch = {
      ...card,
      descData: deserializeJSONString(card.descData),
    };

    dispatch(loadCardSuccess(dataToDispatch));
  };
};
